import { Box, styled } from '@mui/material';

export const SegmentTabsContainer = styled(Box, {
  shouldForwardProp: (prop: string) => !['variant', 'customHeight'].includes(prop),
})<{ variant: 'base' | 'dark'; customHeight?: string }>(({ theme, variant, customHeight }) => {
  if (variant === 'base') {
    return {
      width: '100%',
      '& .mbsc-segmented': {
        margin: 0,
        padding: '2px',
        backgroundColor: theme.palette.case.neutral.n0,
        border: `1px solid ${theme.palette.case.neutral.n200}`,
        '& .mbsc-segmented-button': {
          color: theme.palette.case.neutral.n600,
          fontSize: '10px',
          fontWeight: '500',
          padding: '1px 8px',
        },
        '& .mbsc-segmented-item-selected': {
          '& .mbsc-segmented-button': {
            color: theme.palette.case.neutral.n800,
          },
        },
        '& .mbsc-segmented-selectbox-inner': {
          backgroundColor: theme.palette.case.neutral.n200,
          boxShadow: '1px 1px 3px 0px rgba(38, 44, 74, 0.12)',
        },
        '& .mbsc-segmented-selectbox': {
          padding: '0px',
        },
      },
    };
  } else {
    return {
      width: '100%',
      height: customHeight ? customHeight : '40px',
      '& .mbsc-segmented': {
        margin: 0,
        padding: '3px',
        backgroundColor: theme.palette.case.neutral.n0,
        height: customHeight ? '100%' : 'max-content',
        border: `1px solid ${theme.palette.case.neutral.n200}`,

        '& .mbsc-segmented-button': {
          color: theme.palette.case.neutral.n600,
          fontSize: '14px',
          fontWeight: '400',
          height: '100%',
          display: 'flex',
          padding: '0px 12px',
          alignItems: 'center',
          svg: {
            path: {
              fill: `${theme.palette.case.neutral.n500}`,
            },
          },
        },

        '& .mbsc-segmented-item-selected': {
          '& .mbsc-segmented-button': {
            color: theme.palette.case.neutral.n0,
          },
          svg: {
            path: {
              fill: `${theme.palette.case.neutral.n0} !important`,
            },
          },
        },
        '& .mbsc-segmented-selectbox-inner': {
          backgroundColor: theme.palette.case.neutral.n800,
          boxShadow: '0px 2px 8px 0px rgba(38, 44, 74, 0.08)',
        },
        '& .mbsc-segmented-selectbox': {
          padding: '0px',
        },
      },
    };
  }
});
